module.exports = __webpack_public_path__ + "static/media/sylvando.468aa6d8.png";